module.exports = __webpack_public_path__ + "img/42_33.244b29ce.png";